import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  IconButton,
} from "@material-ui/core";
import {
  Dvr
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  table: {
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "105px",
  },
  limitCol: {
    textAlign: "center",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  
}));

function Users(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [users, setUsers] = React.useState([]);
  const [adminName, setAdminName] = React.useState([]);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 顧客データ調査";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    setAdminName(JSON.parse(localStorage.getItem("adminuser")).name)
    fetchUsers();
  }, [auth.state.token]);

  const fetchUsers = () => {
    request({
      method: "GET",
      url: `admin/accounts`,
    }).then((result) => {
      setUsers(result.data.data);
    });
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.master.email}</TableCell>
          <TableCell>{row.contract_type}</TableCell>
          <TableCell>{row.connected_at ? '接続中' : '未接続'}</TableCell>
          <TableCell className={classes.dateCol}>{dayjs(row.created_at).format("YYYY/MM/DD HH:mm:ss")}</TableCell>
          <TableCell className={classes.dateCol}>{row.updated_at ? dayjs(row.updated_at).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell>
            <IconButton 
              color="primary" 
              aria-label="add an DesktopWindows"
              disabled={row.deleted_at}
              component={Link} 
              //  Update 2023.03.31 投稿分類
              //to={`/admin/customerScreen/view?account_id=${row.id}&adminname=${adminName}&contract_type=${row.contract_type}&media=${row.options.media}&admintoken=${auth.state.token}`}
              to={`/admin/customerScreen/view?account_id=${row.id}&adminname=${adminName}&contract_type=${row.contract_type}&media=${row.options.media}&analysis=${row.options.analysis}&admintoken=${auth.state.token}`}
            >
              <Dvr />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                アカウント一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>名前</TableCell>
                    <TableCell>マスターアドレス</TableCell>
                    <TableCell>タイプ</TableCell>
                    <TableCell>FH受信状態</TableCell>
                    <TableCell>作成日</TableCell>
                    <TableCell>更新日</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map(
                    function (row, index) {
                      return <Row key={index} index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </>
      }
    />
  );
}

export default withRouter(Users);
